import ConsentDefaults from 'constants/consentDefaults'

import CookieConsents from 'utils/cookieConsents'

import consentAllForScanner from './consentAllForScanner'


/**
 * @param {object} args
 * @param {number} args.cookiePolicyVersion
 */
export default function makeConsentAll({ cookiePolicyVersion }) {
  /**
   * @name consentAll
   *
   * @param {object} [args]
   * @param {number} args.isPersistent - stores consents in browser when true
   */
  return async ({ isPersistent } = {}) => {
    // Persist consent before unblocking. The unblock cascade replaces
    // auto-blocked nodes via cloneNode + replaceWith, which fires the
    // auto-blocker's MutationObserver on the inserted clone. The MO
    // reads CookieConsents to decide whether to re-block — if consent
    // isn't recorded yet, it re-blocks the freshly-unblocked node.
    //
    if ( isPersistent ) {
      CookieConsents.setConsents({
        ...ConsentDefaults.OPT_OUT,
        document_version_id: cookiePolicyVersion,
      })
    }

    await consentAllForScanner({ isTemporary: !isPersistent })
  }
}
